Croppie = window.Croppie || {};

Croppie.extension = 'png';
Croppie.c = null;

Croppie.init = function (config) {
	if (config === undefined || config.preview === undefined) {
		return false;
	}
	var options = config.options ? config.options : {},
		width = config.width ? config.width : 400,
		ratio = config.ratio ? config.ratio : 0.667,
		outputWidth = config.outputWidth ? config.outputWidth : 1200;

	Croppie.c = $(config.preview).croppie($.extend({
		viewport: {
			width: width,
			height: width * ratio
		},
		boundary: {
			width: width,
			height: width * ratio
		},
		enableExif: true,

		update: function (data) {
			Croppie.c.croppie('result', {
				type: 'canvas',
				format: Croppie.extension,
				quality: '1',
				size: {
					width: outputWidth
				}
			}).then(function (ret) {
				$(config.output).val(ret);
			});
		}
	}, options));

	if ($(config.upload) && $(config.upload).length > 0) {
		$(config.upload).on('change', function () {
			readFile(this);
		});
	}
	if ($(config.output) && $(config.output).length > 0) {
		Croppie.c.croppie('bind', {
			url: $(config.output).val()
		});
		var regExp = /^data:image\/(.*);base64/i;
		var matches = regExp.exec($(config.output).val());
		if (matches) {
			Croppie.extension = matches[1];
		}
	}

	function readFile(input) {
		if (input.files && input.files[0]) {
			Croppie.extension = input.files[0].type.split('/').pop();
			var reader = new FileReader();
			reader.onload = function (event) {
				Croppie.c.croppie('bind', {
					url: event.target.result
				});
			};

			reader.readAsDataURL(input.files[0]);
		} else {
			alert('Sorry - you\'re browser doesn\'t support the FileReader API');
		}
	}
};
